import { useCallback } from "react";

import { inferRouterOutputs } from "@trpc/server";

import { AppRouterType, trpc } from "@/helpers/trpc";

export type CommunicationFormData = inferRouterOutputs<AppRouterType>["getFormData"];

export const useFormCommunicationData = (formId?: string) => {
  const {
    data: formData,
    refetch,
    isLoading: isFormDataLoading,
  } = trpc.getFormData.useQuery({
    formId,
  });

  const refetchFormData = useCallback(() => {
    if (formId) {
      refetch();
    }
  }, [refetch, formId]);

  return {
    loading: isFormDataLoading,
    data: formData,
    refetchFormData,
  };
};
